import React from 'react';
import './DocumentTable.css';

interface Document {
  id: string;
  rawId?: number;
  restaurant: string;
  documentType: string;
  status: 'pending' | 'approved' | 'rejected' | 'needs-info';
  uploadDate: string;
  reviewer: string;
  hasInfo?: boolean;
}

interface DocumentTableProps {
  documents: Document[];
  selectedDocuments: string[];
  onSelectDocument: (documentId: string) => void;
  onSelectAll: () => void;
  onView?: (document: Document) => void;
  onApprove?: (document: Document) => void;
  onReject?: (document: Document) => void;
}

const DocumentTable: React.FC<DocumentTableProps> = ({
  documents,
  selectedDocuments,
  onSelectDocument,
  onSelectAll,
  onView,
  onApprove,
  onReject,
}) => {
  const allSelected = selectedDocuments.length === documents.length && documents.length > 0;

  const getStatusClass = (status: string) => {
    return status.toLowerCase().replace(' ', '-');
  };

  return (
    <div className="document-table-container">
      <table className="document-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onSelectAll}
                className="table-checkbox"
              />
            </th>
            <th>Document ID</th>
            <th>Restaurant</th>
            <th>Document Type</th>
            <th>Status</th>
            <th>Upload Date</th>
            <th>Reviewer</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((document) => (
            <tr key={document.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedDocuments.includes(document.id)}
                  onChange={() => onSelectDocument(document.id)}
                  className="table-checkbox"
                />
              </td>
              <td className="document-id">{document.id}</td>
              <td className="document-restaurant">{document.restaurant}</td>
              <td className="document-type">
                {document.documentType}
                {document.hasInfo && (
                  <span className="document-info-icon" title="Additional information required">ℹ️</span>
                )}
              </td>
              <td>
                <span className={`document-status status-${getStatusClass(document.status)}`}>
                  {document.status === 'needs-info' ? 'Needs Info' : document.status}
                </span>
              </td>
              <td className="document-upload-date">{document.uploadDate}</td>
              <td className="document-reviewer">{document.reviewer || '-'}</td>
              <td>
                <div className="document-actions">
                  <button 
                    className="document-action-btn view-btn"
                    onClick={() => onView?.(document)}
                    title="View"
                  >
                    View
                  </button>
                  {document.status === 'pending' && (
                    <>
                      <button 
                        className="document-action-btn approve-btn"
                        onClick={() => onApprove?.(document)}
                        title="Approve"
                      >
                        ✓
                      </button>
                      <button 
                        className="document-action-btn reject-btn"
                        onClick={() => onReject?.(document)}
                        title="Reject"
                      >
                        ×
                      </button>
                    </>
                  )}
                  <button className="document-action-btn more-btn" title="More options">
                    ⋯
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DocumentTable;

